import React from 'react';
import PropTypes from 'prop-types';
import {
  CountText,
  TitleText,
  IconWrapper,
  ContentWrapper,
  PercentageLabel,
  PercentageAmount,
  PercentageWrapper,
} from './redesignedStatsCardStyled';
import MDBox from 'components/MDBox';
import Icon from '@mui/material/Icon';
import { StyledStatsCard } from './dashboardStyled';

function RedesignedStatsCard({
  icon,
  title,
  count,
  variant,
  iconColor,
  percentage,
  bordercolor,
  iconBgColor,
}) {
  const isSmall = variant === 'small' || variant === 'plain';
  const isPlain = variant === 'plain';

  return (
    <StyledStatsCard bordercolor={bordercolor} variant={variant}>
      <MDBox p={isSmall ? 1.5 : 2}>
        <ContentWrapper>
          <MDBox>
            <TitleText isSmall={isSmall}>{title}</TitleText>

            <CountText isSmall={isSmall}>{count}</CountText>

            {percentage && !isSmall && !isPlain && (
              <PercentageWrapper>
                <PercentageAmount color={percentage.color}>
                  {percentage.amount}
                </PercentageAmount>
                <PercentageLabel>{percentage.label}</PercentageLabel>
              </PercentageWrapper>
            )}
          </MDBox>

          <IconWrapper
            isSmall={isSmall}
            isPlain={isPlain}
            bgcolor={iconBgColor}
            iconColor={iconColor}
          >
            {typeof icon === 'string' ? (
              <Icon fontSize={isSmall ? 'small' : 'medium'}>{icon}</Icon>
            ) : (
              React.cloneElement(icon, {
                fontSize: isSmall ? 'small' : 'medium',
              })
            )}
          </IconWrapper>
        </ContentWrapper>
      </MDBox>
    </StyledStatsCard>
  );
}

RedesignedStatsCard.defaultProps = {
  iconColor: '',
  iconBgColor: '',
  bordercolor: '',
  percentage: null,
  variant: 'default',
};

RedesignedStatsCard.propTypes = {
  iconColor: PropTypes.string,
  percentage: PropTypes.shape({
    color: PropTypes.string,
    label: PropTypes.string,
    amount: PropTypes.string,
  }),
  bordercolor: PropTypes.string,
  iconBgColor: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'small', 'plain']),
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default RedesignedStatsCard;
